import { Component } from "@angular/core";

@Component({
	templateUrl: "./user-dashboard.component.html",
})
export class UserDashboardComponent { }
